var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { Contract, ethers } from 'ethers';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../context/user';
import { CurrencyTokenSymbol, currencyTokensWithEnv } from '../../data/currency-tokens/currency-tokens';
import { ethValidChainId, polygonValidChainId } from '../../utils/blockchain';
export function useMetamask(connectOnLoad, chain) {
    var t = useI18n().t;
    var _a = useContext(UserContext), user = _a.user, localWalletAddress = _a.localWalletAddress;
    var _b = useState(false), metamaskConnected = _b[0], setMetamaskConnected = _b[1];
    var _c = useState(undefined), metamaskWalletAddress = _c[0], setMetamaskWalletAddress = _c[1];
    var _d = useState(''), userBalance = _d[0], setUserBalance = _d[1];
    var _e = useState(undefined), balancesOnEthBC = _e[0], setBalancesOnEthBC = _e[1];
    var _f = useState(undefined), metamaskErrorMessage = _f[0], setMetamaskErrorMessage = _f[1];
    var _g = useState(false), metamaskInitialized = _g[0], setMetamaskInitalized = _g[1];
    var _h = useState(false), isRequestPending = _h[0], setIsRequestPending = _h[1];
    useEffect(function () {
        function initialize() {
            return __awaiter(this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!connectOnLoad) return [3 /*break*/, 2];
                            return [4 /*yield*/, connectMetamask()
                                // if (window.ethereum) {
                                //   window.ethereum.on('chainChanged', connectMetamask)
                                //   window.ethereum.on('accountsChanged', connectMetamask)
                                // }
                            ];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2:
                            // if (window.ethereum) {
                            //   window.ethereum.on('chainChanged', connectMetamask)
                            //   window.ethereum.on('accountsChanged', connectMetamask)
                            // }
                            setMetamaskConnected(Boolean((_a = window.ethereum) === null || _a === void 0 ? void 0 : _a.selectedAddress));
                            setMetamaskWalletAddress((_b = window.ethereum) === null || _b === void 0 ? void 0 : _b.selectedAddress);
                            setMetamaskInitalized(true);
                            return [2 /*return*/];
                    }
                });
            });
        }
        initialize();
    }, []);
    useEffect(function () {
        setMetamaskErrorMessage(undefined);
        getBalancesOnEthBC();
    }, [localWalletAddress]);
    function getErc20Balance(walletAddress, tokenContractAddress) {
        return __awaiter(this, void 0, void 0, function () {
            var provider, erc20Abi, contract, rawBalance, decimals;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.ethereum && !walletAddress && !tokenContractAddress)
                            return [2 /*return*/];
                        provider = new ethers.BrowserProvider(window.ethereum);
                        erc20Abi = [
                            'function balanceOf(address owner) view returns (uint256)',
                            'function decimals() view returns (uint8)',
                        ];
                        contract = new Contract(tokenContractAddress, erc20Abi, provider);
                        if (!contract) return [3 /*break*/, 3];
                        return [4 /*yield*/, contract.balanceOf(walletAddress)
                            // Fetch the decimals (default to 18 if not available)
                        ];
                    case 1:
                        rawBalance = _a.sent();
                        return [4 /*yield*/, contract.decimals()];
                    case 2:
                        decimals = _a.sent();
                        return [2 /*return*/, {
                                balance: rawBalance,
                                decimals: decimals,
                            }]; // Token balance in smallest unit (e.g., wei)
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function getBalancesOnEthBC() {
        return __awaiter(this, void 0, void 0, function () {
            var cta, game, custom, local, mpcWalletL1GetBalances_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cta = undefined;
                        game = undefined;
                        custom = undefined;
                        local = undefined;
                        if (!(localWalletAddress && metamaskInitialized && metamaskConnected)) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(currencyTokensWithEnv.map(function (token) { return __awaiter(_this, void 0, void 0, function () {
                                var balance, result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(token.symbol === CurrencyTokenSymbol.ETH)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, window.ethereum.request({
                                                    method: 'eth_getBalance',
                                                    params: [localWalletAddress, 'latest'],
                                                })];
                                        case 1:
                                            balance = (_a.sent());
                                            setUserBalance(ethers.formatEther(balance));
                                            return [2 /*return*/, {
                                                    balance: BigInt(balance.toString()).toString(),
                                                    preparing_withdrawal: '0',
                                                    withdrawable: '0',
                                                    symbol: token.symbol,
                                                    token_address: '',
                                                }];
                                        case 2:
                                            if (!token.address) return [3 /*break*/, 4];
                                            return [4 /*yield*/, getErc20Balance(localWalletAddress, token.address)];
                                        case 3:
                                            result = _a.sent();
                                            if (result) {
                                                return [2 /*return*/, {
                                                        balance: result.balance.toString(),
                                                        preparing_withdrawal: '0',
                                                        withdrawable: '0',
                                                        symbol: token.symbol,
                                                        token_address: token.address,
                                                    }];
                                            }
                                            _a.label = 4;
                                        case 4: 
                                        // Return a default structure if no balance is fetched
                                        return [2 /*return*/, {
                                                balance: '0',
                                                preparing_withdrawal: '0',
                                                withdrawable: '0',
                                                symbol: token.symbol,
                                                token_address: token.address || '',
                                            }];
                                    }
                                });
                            }); }))];
                    case 1:
                        local = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!((user === null || user === void 0 ? void 0 : user.coldWalletAddress) &&
                            metamaskInitialized &&
                            metamaskConnected &&
                            (user === null || user === void 0 ? void 0 : user.coldWalletAddress) === localWalletAddress)) return [3 /*break*/, 4];
                        return [4 /*yield*/, Promise.all(currencyTokensWithEnv.map(function (token) { return __awaiter(_this, void 0, void 0, function () {
                                var balance, result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(token.symbol === CurrencyTokenSymbol.ETH)) return [3 /*break*/, 2];
                                            return [4 /*yield*/, window.ethereum.request({
                                                    method: 'eth_getBalance',
                                                    params: [user.coldWalletAddress, 'latest'],
                                                })];
                                        case 1:
                                            balance = (_a.sent());
                                            setUserBalance(ethers.formatEther(balance));
                                            return [2 /*return*/, {
                                                    balance: BigInt(balance.toString()).toString(),
                                                    preparing_withdrawal: '0',
                                                    withdrawable: '0',
                                                    symbol: token.symbol,
                                                    token_address: '',
                                                }];
                                        case 2:
                                            if (!(token.address && user.coldWalletAddress)) return [3 /*break*/, 4];
                                            return [4 /*yield*/, getErc20Balance(user.coldWalletAddress, token.address)];
                                        case 3:
                                            result = _a.sent();
                                            if (result) {
                                                return [2 /*return*/, {
                                                        balance: result.balance.toString(),
                                                        preparing_withdrawal: '0',
                                                        withdrawable: '0',
                                                        symbol: token.symbol,
                                                        token_address: token.address,
                                                    }];
                                            }
                                            _a.label = 4;
                                        case 4: 
                                        // Return a default structure if no balance is fetched
                                        return [2 /*return*/, {
                                                balance: '0',
                                                preparing_withdrawal: '0',
                                                withdrawable: '0',
                                                symbol: token.symbol,
                                                token_address: token.address || '',
                                            }];
                                    }
                                });
                            }); }))];
                    case 3:
                        custom = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!(user === null || user === void 0 ? void 0 : user.mpcWalletAddress)) return [3 /*break*/, 7];
                        return [4 /*yield*/, gqlSdk.mpcWalletL1GetBalances()];
                    case 5:
                        mpcWalletL1GetBalances_1 = (_a.sent()).mpcWalletL1GetBalances;
                        return [4 /*yield*/, Promise.all(currencyTokensWithEnv.map(function (token) {
                                if (token.symbol === CurrencyTokenSymbol.ETH) {
                                    var findedToken = mpcWalletL1GetBalances_1.find(function (balance) { return balance.tokenAddress === token.address; });
                                    if (findedToken) {
                                        return {
                                            balance: BigInt(findedToken.balance.toString()).toString(),
                                            preparing_withdrawal: '0',
                                            withdrawable: '0',
                                            symbol: token.symbol,
                                            token_address: token.address,
                                        };
                                    }
                                }
                                else if (token.address) {
                                    // Fetch ERC20 token balance
                                    var findedToken = mpcWalletL1GetBalances_1.find(function (balance) { return balance.tokenAddress === token.address; });
                                    if (findedToken) {
                                        return {
                                            balance: findedToken.balance.toString(),
                                            preparing_withdrawal: '0',
                                            withdrawable: '0',
                                            symbol: token.symbol,
                                            token_address: token.address,
                                        };
                                    }
                                }
                                return {
                                    balance: '0',
                                    preparing_withdrawal: '0',
                                    withdrawable: '0',
                                    symbol: token.symbol,
                                    token_address: token.address || '',
                                };
                            }))];
                    case 6:
                        cta = _a.sent();
                        _a.label = 7;
                    case 7:
                        setBalancesOnEthBC({
                            cta: cta,
                            game: game,
                            custom: custom,
                            local: local,
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function connectMetamask() {
        return __awaiter(this, void 0, Promise, function () {
            var chainIdReq, accountsReq, balance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.ethereum) {
                            setMetamaskErrorMessage(t('error.metamask-not-installed'));
                            return [2 /*return*/];
                        }
                        if (isRequestPending) {
                            return [2 /*return*/];
                        }
                        setIsRequestPending(true);
                        return [4 /*yield*/, window.ethereum.request({ method: 'eth_chainId' })];
                    case 1:
                        chainIdReq = _a.sent();
                        if (chain === 'polygon' && chainIdReq !== polygonValidChainId) {
                            setMetamaskErrorMessage(t('error.incorrect-network-polygon'));
                            setIsRequestPending(false);
                            return [2 /*return*/];
                        }
                        if (chain === 'eth' && chainIdReq !== ethValidChainId) {
                            setMetamaskErrorMessage(t('error.incorrect-network-eth'));
                            setIsRequestPending(false);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, window.ethereum.request({ method: 'eth_requestAccounts' })];
                    case 2:
                        accountsReq = (_a.sent());
                        if (accountsReq && accountsReq[0]) {
                            setMetamaskWalletAddress(accountsReq[0]);
                            setMetamaskConnected(true);
                        }
                        return [4 /*yield*/, window.ethereum.request({
                                method: 'eth_getBalance',
                                params: [accountsReq[0], 'latest'],
                            })];
                    case 3:
                        balance = (_a.sent());
                        setUserBalance(ethers.formatEther(balance));
                        setIsRequestPending(false);
                        return [2 /*return*/, accountsReq && accountsReq[0] ? accountsReq[0] : undefined];
                }
            });
        });
    }
    function personalSignMessage(address, message) {
        if (!window.ethereum) {
            setMetamaskErrorMessage(t('error.metamask-not-installed'));
            throw new Error('MetaMask is not installed');
        }
        return window.ethereum.request({
            method: 'personal_sign',
            params: [address, message],
        });
    }
    function transferERC20(contractAddress, toAddress, amount) {
        return __awaiter(this, void 0, Promise, function () {
            var provider, signer, erc20Abi, tokenContract, tokenDecimals, formattedAmount, tx, _err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof window.ethereum === 'undefined') {
                            setMetamaskErrorMessage(t('error.metamask-not-installed'));
                            return [2 /*return*/, false];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, window.ethereum.request({ method: 'eth_requestAccounts' })];
                    case 2:
                        _a.sent();
                        provider = new ethers.BrowserProvider(window.ethereum);
                        return [4 /*yield*/, provider.getSigner()];
                    case 3:
                        signer = _a.sent();
                        erc20Abi = [
                            'function transfer(address to, uint256 amount) public returns (bool)',
                            'function decimals() view returns (uint8)',
                        ];
                        tokenContract = new Contract(contractAddress, erc20Abi, signer);
                        return [4 /*yield*/, tokenContract.decimals()];
                    case 4:
                        tokenDecimals = _a.sent();
                        formattedAmount = ethers.parseUnits(amount.toString(), tokenDecimals);
                        return [4 /*yield*/, tokenContract.transfer(toAddress, formattedAmount)];
                    case 5:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 6:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 7:
                        _err_1 = _a.sent();
                        // console.error("Error transferring tokens:", error)
                        // setMetamaskErrorMessage(error.message)
                        return [2 /*return*/, false];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function transferETH(toAddress, amount) {
        return __awaiter(this, void 0, Promise, function () {
            var provider, signer, formattedAmount, tx, _err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof window.ethereum === 'undefined') {
                            setMetamaskErrorMessage('MetaMask is not installed');
                            return [2 /*return*/, false];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, window.ethereum.request({ method: 'eth_requestAccounts' })];
                    case 2:
                        _a.sent();
                        provider = new ethers.BrowserProvider(window.ethereum);
                        return [4 /*yield*/, provider.getSigner()];
                    case 3:
                        signer = _a.sent();
                        formattedAmount = ethers.parseEther(amount.toString());
                        return [4 /*yield*/, signer.sendTransaction({
                                to: toAddress,
                                value: formattedAmount,
                            })];
                    case 4:
                        tx = _a.sent();
                        return [4 /*yield*/, tx.wait()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, true];
                    case 6:
                        _err_2 = _a.sent();
                        // console.error("Error transferring ETH:", error)
                        // setMetamaskErrorMessage(error.message)
                        return [2 /*return*/, false];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    return {
        metamaskConnected: metamaskConnected,
        metamaskWalletAddress: metamaskWalletAddress,
        userBalance: userBalance,
        metamaskInitialized: metamaskInitialized,
        connectMetamask: connectMetamask,
        setMetamaskErrorMessage: setMetamaskErrorMessage,
        personalSignMessage: personalSignMessage,
        isRequestPending: isRequestPending,
        balancesOnEthBC: balancesOnEthBC,
        getBalancesOnEthBC: getBalancesOnEthBC,
        transferERC20: transferERC20,
        transferETH: transferETH,
        metamaskErrorMessage: metamaskErrorMessage,
    };
}
